import { LoadingButton } from '@mui/lab';
import {
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    Grid,
    Switch,
    TextField,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import { useMemo, useState } from 'react';
import server from '../../../global/server';
import { useFetch } from '../../../hooks/useFetch';
import useHandleErrors from '../../../hooks/useHandleErrors';
import { useAuth } from '../../Auth/context/AuthContext';

export default () => {
    const { data, mutate, error, isFetching } = useFetch('/user');

    const [errs, setErrs] = useState();
    const [viewDialog, setViewDialog] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    useHandleErrors(errs);
    const { handleChange, handleSubmit, handleReset, setValues, values, errors, isSubmitting } = useFormik({
        initialValues: {
            email: '',
            password: '',
            status: false,
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                if (values.id) {
                    await server.put('/user', values);
                    enqueueSnackbar('Usuário alterado');
                } else {
                    await server.post('/user', values);
                    enqueueSnackbar('Usuário adicionado');
                }
                setSubmitting(false);
                mutate();
                handleReset();
                setViewDialog(false);
            } catch (error) {
                setSubmitting(false);
                setErrs(error);
            }
        },
    });

    const columns = useMemo(() => [
        { field: 'id', headerName: 'ID', width: 50 },
        {
            field: 'email',
            headerName: 'Email',
            flex: 1,
            // valueGetter: params => size(params.value)
        },
        {
            field: 'status',
            headerName: 'Status',
            renderCell: params => (params.value ? <Chip color="success" label="Ativo" /> : <Chip color="error" label="Inativo" />),
        },

        {
            field: 'actions',
            //headerName: 'actions',
            type: 'actions',
            renderCell: params => (
                <Button
                    onClick={e => {
                        setValues(params.row, false);
                        setViewDialog(true);
                    }}
                >
                    Alterar
                </Button>
            ),
        },
    ]);

    const [submitting, setSubmitting] = useState(false);
    const excluir = async id => {
        try {
            setSubmitting(true);
            console.log(id);
            await server.delete('/user', { data: { id } });
            enqueueSnackbar('Item removido');
            setSubmitting(false);
            mutate();
            handleReset();
            setViewDialog(false);
        } catch (error) {
            setSubmitting(false);
            setErrs(error);
        }
    };

    const { user } = useAuth();

    return (
        <>
            <Grid container direction="row" alignItems="center" spacing={2} sx={{ marginBottom: 2 }}>
                <Grid item xs={12} sx={{ textAlign: 'right' }}>
                    <Button variant="contained" onClick={e => setViewDialog(true)}>
                        Adicionar usuário
                    </Button>
                </Grid>
            </Grid>
            <DataGrid autoHeight checkboxSelection loading={isFetching} rows={data || []} columns={columns} />
            <Dialog
                open={viewDialog}
                onClose={e => {
                    handleReset();
                    setViewDialog(false);
                }}
            >
                <DialogTitle>Novo usuário</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} mt={1}>
                        <Grid item xs={12}>
                            <TextField helperText={errors.email} onChange={handleChange} value={values.email} fullWidth name="email" label="E-mail" />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                helperText={errors.password}
                                value={values.password}
                                onChange={handleChange}
                                fullWidth
                                name="password"
                                label="Senha"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Switch disabled={user.id === values.id} name="status" onChange={handleChange} checked={values.status} />
                                    }
                                    label="Status"
                                />
                                <FormHelperText>{errors.status}</FormHelperText>
                            </FormGroup>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    {Boolean(values.id) && (
                        <LoadingButton
                            disabled={user.id === values.id}
                            loading={submitting}
                            color="error"
                            onClick={e => window.confirm('Você confirma a exclusão do item?') && excluir(values.id)}
                        >
                            Excluir
                        </LoadingButton>
                    )}
                    <Button onClick={e => setViewDialog(false)}>Cancelar</Button>
                    <LoadingButton loading={isSubmitting} onClick={handleSubmit}>
                        Salvar
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    );
};
